import { defineMessages } from 'react-intl';

export const scope = 'add_chatbot';

export default defineMessages({
    field_check: {
        id: `${scope}.field_check`,
        defaultMessage: 'All fields are required.',
    },
    create_error: {
        id: `${scope}.create_error`,
        defaultMessage: 'Failed to create app. Please try again.',
    },
    configuration_success: {
        id: `${scope}.configuration_success`,
        defaultMessage: 'Configuration saved successfully.',
    },
    auth_error: {
        id: `${scope}.auth_error`,
        defaultMessage: 'Authorization failed. Please try again later.',
    },
    lauch_error: {
        id: `${scope}.lauch_error`,
        defaultMessage: 'Failed to launch. Please try again.',
    },
});
